import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { fetchWrapper } from "_helpers";
import { alertActions } from "./alert.slice";
// create slice = combination of reducer and action

const name = "docenter";
const initialState = createInitialState();
const extraActions = createExtraActions();
const extraReducers = createExtraReducers();
const slice = createSlice({ name, initialState, extraReducers });
//each slice have 3 elements first is name second is state, then reducer

// exports

export const centerActions = { ...slice.actions, ...extraActions };
export const docenterReducer = slice.reducer;

// implementation

function createInitialState() {
  return {
    // initialize state from local storage to enable user to stay logged in
    list: {
      loading: true,
      docList: [],
    },
    fileList: [],
  };
}

function createExtraActions() {
  const baseUrl = `${process.env.REACT_APP_OCTA_API_URL}`;

  return {
    getFolders: getFolders(),
    getFiles: getFiles(),
    createNewFolder: createNewFolder(),
    addNewFile: addNewFile(),
    updateFileName: updateFileName(),
    updateFolderName: updateFolderName(),
    deleteFiles: deleteFiles(),
    deleteFolder: deleteFolder(),
    deleteMultipleFiles: deleteMultipleFiles(),
    getFolderPermission: getFolderPermission(),
    getPermissionUserList: getPermissionUserList(),
    downloadFiles: downloadFiles(),
    submitShareReq: submitShareReq(),
    docSearch: docSearch(),
  };

  function downloadFiles() {
    return createAsyncThunk(
      `${name}/download-files`,
      async (ids, { dispatch }) => {
        try {
          await fetchWrapper.get(
            `${baseUrl}/document-center/get-file-contents/${ids.join(",")}`
          );
        } catch (error) {
          dispatch(alertActions.error(error));
        }
      }
    );
  }
  function getFolders() {
    return createAsyncThunk(
      `${name}/docenter`,
      async () =>
        await fetchWrapper.get(`${baseUrl}/document-center/get-folders`)
    );
  }
  function getFiles() {
    return createAsyncThunk(
      `${name}/getFiles`,
      async (id) =>
        await fetchWrapper.get(`${baseUrl}/document-center/get-files/${id}`)
    );
  }

  function addNewFile() {
    return createAsyncThunk(`${name}/create`, async (data, { dispatch }) => {
      try {
        await fetchWrapper.post(
          `${baseUrl}/document-center/add-edit-file`,
          data,
          "multipart"
        );
        dispatch(centerActions.getFiles(data.get("folderId")));
        dispatch(centerActions.getFolders());
      } catch (error) {
        dispatch(alertActions.error(error));
      }
    });
  }
  function createNewFolder() {
    return createAsyncThunk(
      `${name}/get-folders`,
      async (data, { dispatch }) => {
        try {
          await fetchWrapper.post(
            `${baseUrl}/document-center/add-edit-folder`,
            data
          );
          dispatch(centerActions.getFolders());
        } catch (error) {
          dispatch(alertActions.error(error));
        }
      }
    );
  }
  function updateFileName() {
    return createAsyncThunk(
      `${name}/add-edit-file`,
      async (data, { dispatch }) => {
        try {
          await fetchWrapper.post(`${baseUrl}/document-center/add-edit-file`, {
            id: data.id,
            name: data.name,
          });
          dispatch(centerActions.getFiles(data.selectedFolderId));
        } catch (error) {
          dispatch(alertActions.error(error));
        }
      }
    );
  }
  function updateFolderName() {
    return createAsyncThunk(
      `${name}/add-edit-folder`,
      async (data, { dispatch }) => {
        try {
          await fetchWrapper.post(
            `${baseUrl}/document-center/add-edit-folder`,
            data
          );
          dispatch(centerActions.getFolders());
        } catch (error) {
          dispatch(alertActions.error(error));
        }
      }
    );
  }
  function deleteFiles() {
    return createAsyncThunk(
      `${name}/delete-file`,
      async (data, { dispatch }) => {
        try {
          await fetchWrapper.delete(
            `${baseUrl}/document-center/delete-file/${data.fileId}`
          );
          dispatch(centerActions.getFiles(data.folderId));
        } catch (error) {
          dispatch(alertActions.error(error));
        }
      }
    );
  }
  function deleteFolder() {
    return createAsyncThunk(
      `${name}/delete-folder`,
      async (id, { dispatch }) => {
        try {
          await fetchWrapper.delete(
            `${baseUrl}/document-center/delete-folder/${id}`
          );
          dispatch(centerActions.getFolders());
        } catch (error) {
          dispatch(alertActions.error(error));
        }
      }
    );
  }
  function deleteMultipleFiles() {
    return createAsyncThunk(
      `${name}/delete-files`,
      async (data, { dispatch }) => {
        try {
          await fetchWrapper.delete(`${baseUrl}/document-center/delete-files`, {
            ids: data.ids,
          });
          dispatch(centerActions.getFiles(data.folderId));
        } catch (error) {
          dispatch(alertActions.error(error));
        }
      }
    );
  }
  /* Folder Permission */
  function getFolderPermission() {
    return createAsyncThunk(
      `${name}/view-folder-permission`,
      async (id, { dispatch }) => {
        try {
          dispatch(centerActions.getFolders());
          dispatch(centerActions.getFiles(id));
          return await fetchWrapper.get(
            `${baseUrl}/document-center/view-folder-permission/${id}`
          );
        } catch (error) {
          dispatch(alertActions.error(error));
        }
      }
    );
  }
  function getPermissionUserList() {
    return createAsyncThunk(
      `${name}/get-permissions-users-listing`,
      async (id, { dispatch }) => {
        try {
          return await fetchWrapper.get(
            `${baseUrl}/document-center/get-permissions-users-listing/${id}`
          );
        } catch (error) {
          dispatch(alertActions.error(error));
        }
      }
    );
  }
  function submitShareReq() {
    return createAsyncThunk(
      `${name}/add-edit-folder-permission`,
      async (data, { dispatch }) => {
        try {
          return await fetchWrapper.post(
            `${baseUrl}/document-center/add-edit-folder-permission/`,
            data
          );
        } catch (error) {
          dispatch(alertActions.error(error));
        }
      }
    );
  }
  /* End Folder Permission */
  /*Searching */
  function docSearch() {
    return createAsyncThunk(
      `${name}/search`,
      async (val) =>
        await fetchWrapper.get(
          `${baseUrl}/document-center/get-folders?search=${val}`
        )
    );
  }
}

function createExtraReducers() {
  return (builder) => {
    getFolders();
    getFiles();
    createNewFolder();
    updateFileName();
    updateFolderName();
    deleteFolder();
    deleteFiles();
    deleteMultipleFiles();
    addNewFile();
    getFolderPermission();
    getPermissionUserList();
    submitShareReq();
    docSearch();
    downloadFiles();
    function getFolders() {
      var { pending, fulfilled, rejected } = extraActions.getFolders;
      builder
        .addCase(pending, (state) => {
          state.docList = { loading: true };
        })
        .addCase(fulfilled, (state, action) => {
          state.list = {
            docList: { data: action.payload?.data },
          };
          state.docList = { loading: false };
        })
        .addCase(rejected, (state, action) => {
          state.docList = { loading: false, error: action.error };
        });
    }

    function getFiles() {
      var { pending, fulfilled, rejected } = extraActions.getFiles;
      builder
        .addCase(pending, (state) => {
          state.docList = { loading: true };
        })
        .addCase(fulfilled, (state, action) => {
          state.fileList = {
            files: action.payload?.data,
          };
          state.docList = { loading: false };
        })
        .addCase(rejected, (state, action) => {
          state.docList = { loading: false, error: action.error };
        });
    }
    function addNewFile() {
      var { pending, fulfilled, rejected } = extraActions.addNewFile;
      builder
        .addCase(pending, (state) => {
          state.docList = { loading: true };
        })
        .addCase(fulfilled, (state, action) => {
          state.docList = { loading: false };
        })
        .addCase(rejected, (state, action) => {
          state.docList = { loading: false, error: action.error };
        });
    }
    function downloadFiles() {
      var { pending, fulfilled, rejected } = extraActions.downloadFiles;
      builder
        .addCase(pending, (state) => {
          state.docList = { loading: true };
        })
        .addCase(fulfilled, (state, action) => {
          state.docList = { loading: false };
        })
        .addCase(rejected, (state, action) => {
          state.docList = { loading: false, error: action.error };
        });
    }
    function createNewFolder() {
      var { pending, fulfilled, rejected } = extraActions.createNewFolder;
      builder
        .addCase(pending, (state) => {
          state.docList = { loading: true };
        })
        .addCase(fulfilled, (state, action) => {
          state.docList = { loading: false };
        })
        .addCase(rejected, (state, action) => {
          state.docList = { loading: false, error: action.error };
        });
    }
    function updateFileName() {
      var { pending, fulfilled, rejected } = extraActions.updateFileName;
      builder
        .addCase(pending, (state) => {
          state.docList = { loading: true };
        })
        .addCase(fulfilled, (state, action) => {
          state.docList = { loading: false };
        })
        .addCase(rejected, (state, action) => {
          state.docList = { loading: false, error: action.error };
        });
    }
    function updateFolderName() {
      var { pending, fulfilled, rejected } = extraActions.updateFolderName;
      builder
        .addCase(pending, (state) => {
          state.docList = { loading: true };
        })
        .addCase(fulfilled, (state, action) => {
          state.docList = { loading: false };
        })
        .addCase(rejected, (state, action) => {
          state.docList = { loading: false, error: action.error };
        });
    }
    function deleteFiles() {
      var { pending, fulfilled, rejected } = extraActions.deleteFiles;
      builder
        .addCase(pending, (state) => {
          state.docList = { loading: true };
        })
        .addCase(fulfilled, (state, action) => {
          state.docList = { loading: false };
        })
        .addCase(rejected, (state, action) => {
          state.docList = { loading: false, error: action.error };
        });
    }
    function deleteFolder() {
      var { pending, fulfilled, rejected } = extraActions.deleteFolder;
      builder
        .addCase(pending, (state) => {
          state.docList = { loading: true };
        })
        .addCase(fulfilled, (state, action) => {
          state.docList = { loading: false };
        })
        .addCase(rejected, (state, action) => {
          state.docList = { loading: false, error: action.error };
        });
    }
    function deleteMultipleFiles() {
      var { pending, fulfilled, rejected } = extraActions.deleteMultipleFiles;
      builder
        .addCase(pending, (state) => {
          state.docList = { loading: true };
        })
        .addCase(fulfilled, (state, action) => {
          state.docList = { loading: false };
        })
        .addCase(rejected, (state, action) => {
          state.docList = { loading: false, error: action.error };
        });
    }
    /*Folder Permission */
    function getFolderPermission() {
      var { pending, fulfilled, rejected } = extraActions.getFolderPermission;
      builder
        .addCase(pending, (state) => {
          state.docList = { loading: true };
        })
        .addCase(fulfilled, (state, action) => {
          state.permissionFolder = {
            res: action.payload?.data,
          };
          state.docList = { loading: false };
        })

        .addCase(rejected, (state, action) => {
          state.docList = { loading: false, error: action.error };
        });
    }
    function getPermissionUserList() {
      var { pending, fulfilled, rejected } = extraActions.getPermissionUserList;
      builder
        .addCase(pending, (state) => {
          state.docList = { loading: true };
        })
        .addCase(fulfilled, (state, action) => {
          state.permissionUserList = {
            user: action.payload?.data,
          };

          state.docList = { loading: false };
        })
        .addCase(rejected, (state, action) => {
          state.docList = { loading: false, error: action.error };
        });
    }
    /*Share Post Action */

    function submitShareReq() {
      var { pending, fulfilled, rejected } = extraActions.submitShareReq;
      builder
        .addCase(pending, (state) => {
          state.docList = { loading: true };
        })
        .addCase(fulfilled, (state, action) => {
          state.docList = { loading: false };
        })
        .addCase(rejected, (state, action) => {
          state.docList = { loading: false, error: action.error };
        });
    }
    function docSearch() {
      var { pending, fulfilled, rejected } = extraActions.docSearch;
      builder
        .addCase(pending, (state) => {
          state.docList = { loading: true };
        })
        .addCase(fulfilled, (state, action) => {
          state.list = {
            docList: { data: action.payload?.data },
          };
          state.fileList = {
            files: action.payload?.data?.[0]?.folder_files,
          };
          state.docList = { loading: false };
        })
        .addCase(rejected, (state, action) => {
          state.docList = { loading: false, error: action.error };
        });
    }
  };
}
